<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <OccurencesForm @submit-requested="submitRequested"></OccurencesForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import OccurencesForm from './OccurencesForm.vue'

  export default {
  components: { OccurencesForm },
  methods: {
    ...mapActions('occurences', ['postOccurence']),
    submitRequested (input) {
      this.postOccurence(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 